import React from 'react';
import PropTypes from 'prop-types';

import Tab from 'fuse-ui/components/Tab';
import Tabs from 'fuse-ui/components/Tabs';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ( {
    secondary: {
        paddingTop: 0,
        width: '100%'
    },
} );

export const RightPaneContentTabs = ( { classes, handleTabChange, tabData, tabIndex } ) => {
    return (
        <>
            {
                tabData.length &&
                ( <Tabs
                    className={classes.secondary}
                    indicatorAlign="bottom"
                    indicatorColor="primary"
                    onChange={handleTabChange}
                    value={tabIndex}
                    variant={tabData.length > 1 ? 'fullWidth' : 'standard'}
                >
                    {
                        tabData.map( ( tab ) => {
                            return (
                                <Tab
                                    data-automation-id={tab.dataAutomationId}
                                    key={tab.dataAutomationId}
                                    label={tab.label}
                                    secondaryStyle
                                />
                            );
                        } )
                    }
                </Tabs> )
            }
        </>
    );
};

RightPaneContentTabs.propTypes = {
    classes: PropTypes.object.isRequired,
    handleTabChange: PropTypes.func.isRequired,
    tabData: PropTypes.arrayOf( PropTypes.shape( {
        dataAutomationId: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    } ) ).isRequired,
    tabIndex: PropTypes.number.isRequired,
};

RightPaneContentTabs.defaultProps = {
    tabData: []
};

export default withStyles( styles )( RightPaneContentTabs );
